/* eslint-disable max-len */
import React from "react";
import { Link } from "react-router-dom";
import { TabButton } from "components/studio/toolbox/actions/Actions.sub.ActionElement.view"
import NavApps from "components/studio/toolbox/actions/Actions.sub.NavApps.view";
import ActionsWizardView from "components/studio/toolbox/actions/Actions.sub.wizard.view";
import ScrollArrow from "components/util/helpers/ScrollArrow";
import "styles/css/studio/Toolbox.css";

const ActionsView = ({
  apps,
  allApps,
  flow,
  studioRef,
  parentId,
  suggestions,
  showSuggestions,
  filtersData,
  actionSearch,
  actionFilters,
  parentProcessNode,
  activeActionId,
  toolboxId,
  isDeveloper,
  isValidator,
  isFilterSectionShown,
  isSuggestionsLoading,
  isWizardAssistant,
  isWizardMode,
  wizardFlow,
  onEnableApp,
  onSearchActions,
  onClickSearchRemove,
  onClickSearchFilter,
  onDragStart,
  onClickAction,
  onClickFilterTab,
  onClickFilterRemove,
  onClickChangeMode,
  reloadFlow
}) =>
  <div className="h-100">
    <div id="toolbox-actions"
      className={"w-100 h-100 d-flex align-items-start position-relative " + 
        (actionSearch != "" || actionFilters.length > 0 ? "flex-column " : "flex-wrap ") + 
        (isValidator ? "validator " : " ") + 
        (isWizardMode ? "wizard-mode" : "")}
    >

      {
        !isValidator &&
          <div className="d-flex align-items-center w-100 justify-content-end mb-2 mt-n1 switch-wrapper">

            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                id="wizard-mode-switch"
                className="custom-control-input"
                checked={isWizardMode}
                onChange={onClickChangeMode}
              />
              <label className="custom-control-label" htmlFor="wizard-mode-switch"></label>
            </div>

            <span className="dropdown-header text-accent font-weight-bold px-0 pt-2 mr-2">
              Modo guiado
            </span>
          </div>
      }

      {
        isWizardMode
          ? <div className="w-100"
            style={{
              marginTop: "-3.25rem",
              height: "calc(100% - 5rem)",
              overflowY: "auto"
            }}
          >
            <ActionsWizardView
              flow={flow}
              studioRef={studioRef}
              parentId={parentId}
              parentProcessNode={parentProcessNode}
              isWizardAssistant={isWizardAssistant}
              wizardFlow={wizardFlow}
              reloadFlow={reloadFlow}
            />
          </div>
          : <>

            <div id="toolbox-search" className="w-100">
              <input type="text" placeholder="Buscar" class="rounded w-100 search-input"
                value={actionSearch} onChange={(event) => onSearchActions(event.target.value)}
              />
              <i className="fas fa-search d-block search-icon"></i>
              <div className="d-flex flex-row-reverse search-cta">

                <i class={"fas fa-filter search-filters py-0 px-2 " +
                  (isFilterSectionShown ? "active" : "")}
                  onClick={onClickSearchFilter}
                ></i>

                {actionSearch != "" ?
                  <i class="fas fa-times search-close py-0 px-2"
                    onClick={onClickSearchRemove}
                  ></i> : null}
              </div>

              <div id="toolbox-tabs"
                className="animate__animated animate__fadeIn animate__faster"
                style={{ display: isFilterSectionShown ? "block" : "none" }}>
                <ScrollArrow
                  scrollAmount={150}
                  backgroundFadeColor={{ red: 235, green: 241, blue: 246 }}
                  leftButtonStyle={{
                    paddingLeft: "2px",
                    paddingRight: "2px"
                  }}
                  rightButtonStyle={{
                    paddingLeft: "2px",
                    paddingRight: "2px"
                  }}
                  arrowsWidth="auto"
                >
                  {filtersData.map(filter =>
                    <TabButton
                      key={filter.name}
                      name={filter.name}
                      label={filter.label}
                      helpMessage={filter?.helpMessage ?? ""}
                      actionFilters={actionFilters}
                      onClickFilterTab={onClickFilterTab}
                      onClickFilterRemove={onClickFilterRemove}
                    />
                  )}
                </ScrollArrow>
              </div>

            </div>

            {actionSearch != "" || actionFilters.length > 0 ?
              <span className={"d-flex justify-content-between dropdown-header pb-3 px-1 search-title " +
                (actionSearch != "" ? "pt-2" : "pt-0")}>
                {actionSearch != "" ? "Búsqueda" : filtersData.find(tab => tab.name == actionFilters[0])?.label}
              </span> : null}

            {/* Temp hide 250731 
                showSuggestions && suggestions.length > 0 &&
                <div className="w-100 animate__animated animate__fadeIn animate__faster">
                  <div className={"w-100 section-title pr-1 d-flex"}
                    style={{ marginTop: "1.15rem", marginBottom: "0.4rem" }}>
                    <label className="w-100 text-left">
                      Sugerencias
                    </label>
                  </div>
                  <CollapseView
                    id="suggestions"
                    flowId={flow.id}
                    mainActions={[...suggestions].splice(0, 1)}
                    hiddenActions={[...suggestions].slice(1)}
                    actionSearch={actionSearch}
                    hiddenPlaceholder={"Más sugerencias"}
                    hasFilters={actionFilters.length > 0}
                    isSuggestion={true}
                    groupActions={false}
                    onClickAction={onClickAction}
                    onDragStart={onDragStart}
                    onEnableApp={onEnableApp}
                  />
                  <div className="suggestion-divider mt-2" />
                </div>
              */}

            <NavApps
              apps={actionSearch != "" ? allApps : apps}
              flowId={flow.id}
              activeActionId={activeActionId}
              toolboxId={toolboxId}
              actionSearch={actionSearch}
              actionFilters={actionFilters}
              isDeveloper={isDeveloper}
              onClickAction={onClickAction}
              onDragStart={onDragStart}
              onEnableApp={onEnableApp}
            />

            {actionSearch != "" && !isFilterSectionShown ?
              <div className="text-center mx-1 no-results">No se encontraron resultados</div>
              : null}

            {!isValidator && (
              <div className="pt-3 pb-3 more-actions-wrapper w-100">
                <div className="more-actions-divider" />
                <Link to="/apps"
                  class="btn btn-sm btn-primary py-1 w-100" data-toggle="collapse">
                  Personalizar acciones
                </Link>
              </div>
            )}

          </>
      }

    </div>
  </div>;

export default ActionsView;
